// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import { createApolloProvider } from '@vue/apollo-option'
import apolloClient from './apollo'
import router from './router'
import './styles/design-system.css'
import { isAuthenticated, setUser, logout } from './auth'
import { ME } from './graphql/auth'

// If a session is already authenticated, refresh the cached user from the
// server so newly-exposed fields (e.g. isStaff) are always up to date, even
// for sessions that logged in before the schema exposed them.
if (isAuthenticated()) {
  apolloClient
    .query({ query: ME, fetchPolicy: 'network-only' })
    .then(({ data }) => {
      if (data && data.me) setUser(data.me)
    })
    .catch(() => {
      // Token invalid/expired → drop the stale session silently.
      logout()
    })
}

const app = createApp(App)
const apolloProvider = createApolloProvider({
  defaultClient: apolloClient,
})

app.use(apolloProvider)
app.use(router)
app.mount('#app')
